import { render } from "./device.vue?vue&type=template&id=17df2381&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"

import "./device.vue?vue&type=style&index=0&id=17df2381&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17df2381"

export default script